<div class="row">
    <div class="col-md-9">
        <div class="pb-3">
            <h4 id="example-radio-group-label" class="role-title">{{ 'teamMember.role_base' | translate }}</h4>
            <div class="d-md-flex">
                @for (role of allBaseRoles; track role)  {
                    <label for="answer-{{role.role}}" class="border bg-grey rounded p-2 m-1 d-flex" 
                           [ngClass]="{'selected': userBaseRole === role} ">
                        <div class="check-mark-wrapper">
                            <input id="answer-{{role.role}}" class="check-mark"
                                    type="radio" name="answer"
                                    [value]='role'
                                    [ngModel]="userBaseRole"
                                    (ngModelChange)="updateBaseRole($event)">
                        </div>
                        <div class="ps-2 pe-1">
                            <p class="role-subtitle ps-1">{{ $safeNavigationMigration(role?.translateKey) | translate }}</p>
                            <p class="ps-1">{{ role.description | translate }}</p>
                        </div>
                    </label>
                }
            </div> 
        </div>
        
        <div>
            <h4 class="role-title">{{ 'teamMember.role_additionnal' | translate }}</h4>
            <form [formGroup]="additionnalRoleForm">

                @for (role of additionnalRoleCheckboxes.controls; track role){
                    <label for="answer-{{role.value.id}}" class="border bg-grey rounded p-2 m-2 d-flex"
                           [ngClass]="{'selected': role.value.checked, 'disabled': !role.value.selectable} "
                           [matTooltip]="'teamMember.role_admin.disabled' | translate"
                           [matTooltipDisabled]="role.value.id !== 'admin' || !isCurrentUser">
                        <div class="check-mark-wrapper">
                            <input id="answer-{{role.value.id}}" class="check-mark"
                                    [disabled]="(role.value.id === 'admin' && isCurrentUser) || !role.value.selectable"
                                    type="checkbox" name="answer"
                                    [(checked)]="role.value.checked"
                                    (change)="updateAdditionnalRoles(role.value.id)">
                        </div>
                        <div class="ps-3">
                            <p class="role-subtitle">{{ role.value.translateKey | translate }}</p>
                            <p>{{ role.value.description | translate }}</p>
                        </div>
                    </label>
                }
            </form>
        </div>
    </div>
    <div class="col-md-3 py-5">
        <ul class="bg-grey feature-list px-2 py-3">
            @for (activeFeature of activeFeatures; track activeFeature.name) {
                <li>
                    @if(activeFeature.active){
                        <i class="fa-solid fa-circle-check pe-2"></i>
                    }@else {
                        <i class="fa-solid fa-times pe-2"></i>
                    }
                    {{ activeFeature.name | translate }}
                </li>
              }
        </ul>
    </div>
</div>

